"use strict";

var _interopRequireDefault = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
var _api = _interopRequireDefault(require("../../api/api"));
var _default = exports.default = {
  name: 'askpush',
  props: {
    type: Number,
    //0-报价 1-询价
    show: Boolean,
    gsid: String,
    vsid: String
  },
  data: function data() {
    return {
      initQCode: 'http://www.weihuabiaoju.com/appDownload.dhtml?ncrypt=()(c)L33E/NY32aX1VkUU366w==',
      showSuccess: false,
      text: {
        priceLabel: '',
        priceInputPlaceholder: '',
        submitTitle: '',
        successMessageTitle: '',
        successMessageTip: ''
      },
      form: {
        price: '',
        remark: ''
      },
      rules: {
        price: [{
          required: true,
          message: '请输入金额',
          trigger: 'blur'
        }, {
          pattern: /^[0-9]+([.]{1}[0-9]{0,2}){0,1}$/,
          message: '请输入正确的金额',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    var that = this;
    if (that.type == 0) {
      that.text = {
        priceLabel: '报价金额',
        priceInputPlaceholder: '请输入你的报价金额（元）',
        submitTitle: '立即报价',
        successMessageTitle: '恭喜您，报价成功！',
        successMessageTip: '报价信息可以通过危化镖局APP进行查看'
      };
    } else {
      that.text = {
        priceLabel: '询价金额',
        priceInputPlaceholder: '请输入你的询价金额（元）',
        submitTitle: '立即询价',
        successMessageTitle: '恭喜您，询价成功！',
        successMessageTip: '询价信息可以通过危化镖局APP进行查看'
      };
    }
  },
  computed: {
    visible: {
      get: function get() {
        return this.show;
      },
      set: function set(newValue) {
        this.$emit("close", newValue);
      }
    }
  },
  methods: {
    clickToSubmit: function clickToSubmit() {
      console.log("fffff");
      if (this.type == 0) {
        this.loadPushData();
      } else {
        this.loadAskData();
      }
    },
    // 提交报价
    loadPushData: function () {
      var _loadPushData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var that, jsonData, params, _yield$Api$apiGetPush, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              that = this;
              jsonData = {
                "version": '1',
                "fun": 'pcgsquote',
                "param": {
                  gsid: that.gsid,
                  quotevalue: that.form.price,
                  quoteexplain: that.form.remark
                }
              };
              params = {
                jsonParamete: JSON.stringify(jsonData)
              };
              _context.next = 5;
              return _api.default.apiGetPushPriceData(params);
            case 5:
              _yield$Api$apiGetPush = _context.sent;
              data = _yield$Api$apiGetPush.data;
              if (data.proCode == '200') {
                that.visible = false;
                that.showSuccess = true;
              } else if (data.proCode == '5017') {
                that.$message({
                  message: '登录失效，请重新登录',
                  type: 'error'
                });
              } else {
                that.$message({
                  message: data.proMsg,
                  type: 'error'
                });
              }
              console.log('pushresult:', this.$root.token);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function loadPushData() {
        return _loadPushData.apply(this, arguments);
      }
      return loadPushData;
    }(),
    //提交询价
    loadAskData: function () {
      var _loadAskData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var that, jsonData, params, result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              that = this;
              jsonData = {
                "version": '1',
                "fun": 'pcvsinquiry',
                "param": {
                  vsid: that.vsid,
                  quotevalue: that.form.price,
                  quoteexplain: that.form.remark
                }
              };
              params = {
                jsonParamete: JSON.stringify(jsonData)
              };
              _context2.next = 5;
              return _api.default.apiGetAskPriceData(params);
            case 5:
              result = _context2.sent;
              if (result.data.proCode == '200') {
                that.visible = false;
                that.showSuccess = true;
              } else if (result.data.proCode == '5017') {
                that.$message({
                  message: '登录失效，请重新登录',
                  type: 'error'
                });
              } else {
                that.$message({
                  message: result.data.proMsg,
                  type: 'error'
                });
              }
              console.log('askresult:', this.$root.token);
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function loadAskData() {
        return _loadAskData.apply(this, arguments);
      }
      return loadAskData;
    }()
  }
};